import React from 'react';
import { Progress as AntdProgress } from 'antd';
import { ProgressProps as AntdProgressProps } from 'antd/lib/progress';
import theme from '../theme';

export const Progress: React.FC<AntdProgressProps> = ({
  strokeColor = theme.getColor('primary'),
  ...props
}) => <AntdProgress {...props} strokeColor={strokeColor} />;

export default Progress;
